import { NavDropdown, ListGroup, Col, Row } from 'react-bootstrap'
import { v4 as uuidv4 } from 'uuid'

const Archives = ({ archives }) => {
  return (
    <>
      <Col>
        <p>არქივი</p>
        <Row className='flex justify-center items-center w-full'>
          <ListGroup>
            <Col>
              <ListGroup.Item>
                {archives &&
                  archives?.[0]?.versions?.files?.map(item => {
                    return (
                      <NavDropdown key={uuidv4()} title={item.folder} id='collasible-nav-dropdown'>
                        {item.attached.map(file => {
                          return (
                            <>
                              <a
                                key={uuidv4()}
                                target={'_blank'}
                                rel='noopener noreferrer'
                                href={process.env.REACT_APP_WEB_URL + '/' + file.html}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginTop: '10px',
                                }}
                              >
                                {file.version}
                              </a>
                            </>
                          )
                        })}
                      </NavDropdown>
                    )
                  })}
                {!archives?.[0]?.versions?.files && (
                  <p className='w-full mx-auto'>არქივი ცარიელია</p>
                )}
              </ListGroup.Item>
            </Col>
          </ListGroup>
        </Row>
      </Col>
    </>
  )
}

export default Archives
